import { useLocale, useTranslation } from '@dreamstack/i18n'
import map from 'lodash/map'
import uniq from 'lodash/uniq'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import tw from 'twin.macro'
import { useParams } from '../hooks/useParams'
import {
  IS_ACCENTRO_WEB,
  SimpleMuiButton,
  getNewsPath,
  useGetNewsTypeUrlPartReverse,
} from '../index'
import { newsBaseUrls } from './getNewsPath'
import { pressBaseUrl } from './getPressUrl'
import type { NewsType } from './newsTypeUrls.static'

const StyledLink = tw.a`mr-px-12 mb-px-12 lg:(mr-px-24 mb-px-24)`
export const NewsTypes: FunctionComponent<React.PropsWithChildren<{ newsTypes: NewsType[] }>> = ({
  newsTypes,
}) => {
  const t = useTranslation()
  const uniqueTypes = uniq(newsTypes)
  const locale = useLocale()
  const params = useParams()
  const { newsTypeUrl } = params
  const newsType = useGetNewsTypeUrlPartReverse()

  const allNewsVariant = !newsTypeUrl ? 'contained' : 'outlined'

  const newsBaseUrl = newsBaseUrls[locale]
  const pressUrl = pressBaseUrl[locale]

  return (
    <div tw="flex flex-wrap">
      {map(uniqueTypes, (type, index) => {
        const href = getNewsPath({ locale: locale, newsType: type, slug: '' })
        const translatedNewsType = t(`accentro:newsTypes.${type}`, { count: 2 })
        const isSelectedType = newsType === type
        const variant = isSelectedType ? 'contained' : 'outlined'
        return (
          <Link
            key={href}
            shallow={false}
            href={href}
            scroll={false}
            passHref
            legacyBehavior
          >
            <StyledLink>
              <SimpleMuiButton
                style={{ fontWeight: isSelectedType ? 600 : 400 }}
                variant={variant}
                size="small"
              >
                {translatedNewsType}
              </SimpleMuiButton>
            </StyledLink>
          </Link>
        )
      })}
      {IS_ACCENTRO_WEB && (
        <Link shallow href={pressUrl} scroll={false} passHref legacyBehavior>
          <StyledLink>
            <SimpleMuiButton
              variant={'outlined'}
              style={{ fontWeight: 400 }}
              size="small"
            >
              {t('accentro:newsTypes:Press')}
            </SimpleMuiButton>
          </StyledLink>
        </Link>
      )}
      <Link shallow href={newsBaseUrl} scroll={false} passHref legacyBehavior>
        <StyledLink>
          <SimpleMuiButton
            variant={allNewsVariant}
            style={{ fontWeight: !newsTypeUrl ? 600 : 400 }}
            size="small"
          >
            {t('accentro:allNews')}
          </SimpleMuiButton>
        </StyledLink>
      </Link>
    </div>
  )
}
